import {
  Outlet,
  createFileRoute,
  stripSearchParams,
} from '@tanstack/react-router';
import { z } from 'zod';

import { SearchResultsPanel } from '../-components/search-results-panel';
import { ThreadListPanel } from '../-components/thread-list-panel';

const defaultIncomingSearch = { tab: 'all' as const };

const incomingSearchSchema = z.object({
  tab: z
    .enum(['all', 'unread'])
    .catch(defaultIncomingSearch.tab)
    .default(defaultIncomingSearch.tab),
});

export const Route = createFileRoute('/_dashboard/mailbox/incoming')({
  validateSearch: incomingSearchSchema,
  search: {
    middlewares: [stripSearchParams(defaultIncomingSearch)],
  },
  component: IncomingMailboxRoute,
});

// The term lives on the mailbox, so every folder swaps its own list for the
// search results while one is set and gets it back the moment it is cleared.
function IncomingMailboxRoute() {
  const { q } = Route.useSearch();
  const panel = q.trim() ? <SearchResultsPanel /> : <ThreadListPanel />;

  return (
    <div className="flex h-full overflow-hidden">
      {panel}
      <Outlet />
    </div>
  );
}
